import React from "react";
import PropTypes from "prop-types";
import "@assets/css/common/style_table.css";

/**
 * 테마 테이블 컴포넌트
 * @param {Object} props - 컴포넌트 속성
 * @param {Array} props.themes - 테마 목록
 * @param {boolean} props.selectAll - 전체 선택 여부
 * @param {Array} props.selectedItems - 선택된 항목 ID 목록
 * @param {Function} props.onSelectAll - 전체 선택 핸들러
 * @param {Function} props.onItemSelect - 항목 선택 핸들러
 * @param {Function} props.onInfoClick - 상세정보 버튼 클릭 핸들러
 * @param {Function} props.onEditClick - 수정 버튼 클릭 핸들러
 * @param {Function} props.onDeleteClick - 삭제 버튼 클릭 핸들러
 */
const ThemeTable = ({
    themes,
    selectAll,
    selectedItems,
    onSelectAll,
    onItemSelect,
    onInfoClick,
    onEditClick,
    onDeleteClick,
}) => {
    return (
        <div className="common-table-container">
            <table className="common-table">
                <thead>
                    <tr>
                        <th>
                            <div className="checkbox-container">
                                <input
                                    type="checkbox"
                                    id="select-all"
                                    checked={selectAll}
                                    onChange={onSelectAll}
                                />
                                <label
                                    htmlFor="select-all"
                                    className="custom-checkbox"
                                ></label>
                            </div>
                        </th>
                        <th>NO</th>
                        <th>테마명</th>
                        <th>사용 기간</th>
                        <th>배포 여부</th>
                        <th>상세정보</th>
                        <th>수정</th>
                        <th>삭제</th>
                    </tr>
                </thead>
                <tbody>
                    {themes.map((theme, index) => (
                        <tr key={theme.id}>
                            <td>
                                <div className="checkbox-container">
                                    <input
                                        type="checkbox"
                                        id={`theme-${theme.id}`}
                                        checked={selectedItems.includes(
                                            theme.id
                                        )}
                                        onChange={(e) =>
                                            onItemSelect(theme.id, e)
                                        }
                                    />
                                    <label
                                        htmlFor={`theme-${theme.id}`}
                                        className="custom-checkbox"
                                    ></label>
                                </div>
                            </td>
                            <td>{theme.id}</td>
                            <td>{theme.themeName}</td>
                            <td className="usage-period">
                                {theme.usagePeriod}
                            </td>
                            <td>{`${theme.deployedBranchCount}/${theme.totalBranchCount}`}</td>
                            <td>
                                <button
                                    className="info-btn"
                                    onClick={() => onInfoClick(theme)}
                                >
                                    <i className="ri-information-line"></i>
                                </button>
                            </td>
                            <td>
                                <button
                                    className="edit-btn"
                                    onClick={() => onEditClick(theme)}
                                >
                                    <i className="ri-pencil-line"></i>
                                </button>
                            </td>
                            <td>
                                <button
                                    className="delete-btn"
                                    onClick={() => onDeleteClick(theme)}
                                >
                                    <i className="ri-close-line"></i>
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

ThemeTable.propTypes = {
    themes: PropTypes.array.isRequired,
    selectAll: PropTypes.bool.isRequired,
    selectedItems: PropTypes.array.isRequired,
    onSelectAll: PropTypes.func.isRequired,
    onItemSelect: PropTypes.func.isRequired,
    onInfoClick: PropTypes.func.isRequired,
    onEditClick: PropTypes.func.isRequired,
    onDeleteClick: PropTypes.func.isRequired,
};

export default ThemeTable;
